import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      common: {
        loading: "Loading...",
        na: "N/A"
      },
      buyTokens: {
        title: "Buy Tokens",
        tokensPerDesign: "{{count}} tokens per design",
        failedLoadPackages: "Failed to load token packages",
        noCheckoutUrl: "No checkout URL received",
        failedCheckout: "Failed to start checkout process",
        whyBuy: "Why Buy Tokens?",
        mostPopular: "MOST POPULAR",
        tokens: "Tokens",
        processing: "Processing...",
        buyNow: "Buy Now",
        featureInstantTitle: "Instant Delivery",
        featureInstantDesc: "Tokens credited to your account immediately",
        featureSecureTitle: "Secure Payment",
        featureFlexibleTitle: "Flexible Options",
        featureFlexibleDesc: "Multiple package sizes to choose from",
        featureEmailTitle: "Email Notifications",
        featureEmailDesc: "Instant confirmations and updates",
        choosePayment: "Choose Payment Method",
        payWithCard: "Pay with Card",
        payWithPayPal: "Pay with PayPal",
        featureSecureDesc: "Protected by Stripe and PayPal secure encryption"
      },
      cart: {
        processingOrder: "Processing order...",
        loadingCart: "Loading cart...",
        title: "Shopping Cart",
        empty: "Your cart is empty",
        itemCount_one: "{{count}} item in your cart",
        itemCount_other: "{{count}} items in your cart",
        addDesignsHint: "Add designs to your cart to start placing orders",
        createDesign: "Create Design",
        removeFromCart: "Remove from cart",
        orderSummary: "Order Summary",
        items: "Items ({{count}})",
        total: "Total",
        yourBalance: "Your Balance",
        insufficientTokens: "Insufficient tokens",
        embroideryFormat: "Embroidery Format",
        autoFromMachine: "Auto-selected from Machine Settings",
        formatFromMachine: "Format will be used from your Machine Settings",
        selectFileFormats: "Select File Formats",
        selectedFormats_one: "{{count}} format selected",
        selectedFormats_other: "{{count}} formats selected",
        doneSelected: "Done ({{count}} selected)",
        placingOrder: "Placing Order...",
        placeOrder: "Place Order",
        buyMoreTokens: "Buy More Tokens",
        continueShopping: "Continue Shopping",
        quantity: "Quantity: 1",
        untitledDesign: "Untitled Design",
        failedLoadCart: "Failed to load cart",
        failedLoadCartRetry: "❌ Failed to load cart. Please try again.",
        removedSuccess: "✅ Item removed from cart",
        failedRemove: "Failed to remove item",
        failedRemoveRetry: "❌ Failed to remove item. Please try again.",
        insufficientTokensMessage: "❌ Insufficient tokens. Please purchase more tokens.",
        placedSuccess: "✅ Order placed successfully!",
        failedPlaceOrder: "Failed to place order",
        failedPlaceOrderRetry: "❌ Failed to place order. Please try again.",
        designSize: "Design Size",
        fileFormat: "File Format",
        failedUpdate: "Failed to update cart item",
        failedUpdateRetry: "Failed to update cart item. Please try again."
      },
      settings: {
        title: "Settings",
        subtitle: "Manage your account",
        profileStats: "Profile Statistics",
        totalDesigns: "Total Designs",
        totalOrders: "Total Orders",
        tokenBalance: "Token Balance",
        memberSince: "Member Since",
        profileInfo: "Profile Information",
        verified: "✓ Verified",
        unverified: "⚠ Unverified",
        firstName: "First Name",
        lastName: "Last Name",
        emailAddress: "Email Address",
        saving: "Saving...",
        saveChanges: "Save Changes",
        changePassword: "Change Password",
        currentPassword: "Current Password",
        newPassword: "New Password",
        confirmNewPassword: "Confirm New Password",
        updating: "Updating...",
        updatePassword: "Update Password",
        transactionHistory: "Token Transaction History",
        noTransactions: "No transactions yet",
        date: "Date",
        type: "Type",
        amount: "Amount",
        description: "Description",
        balanceAfter: "Balance After",
        accountActions: "Account Actions",
        signOut: "Sign Out",
        failedLoadProfile: "Failed to load profile",
        failedLoadProfileRetry: "❌ Failed to load profile. Please try again.",
        profileUpdated: "✅ Profile updated successfully",
        failedUpdateProfile: "Failed to update profile",
        failedUpdateProfileRetry: "❌ Failed to update profile. Please try again.",
        passwordsNoMatch: "❌ New passwords do not match",
        passwordChanged: "✅ Password changed successfully",
        failedChangePassword: "Failed to change password",
        failedChangePasswordRetry: "❌ Failed to change password. Please try again."
      },
      orders: {
        title: "Orders",
        searchPlaceholder: "Search orders...",
        allStatus: "All Status",
        status: {
          pending_payment: "Pending Payment",
          processing: "Processing",
          completed: "Completed",
          failed: "Failed",
          cancelled: "Cancelled"
        },
        failedLoad: "Failed to load orders",
        failedLoadRetry: "❌ Failed to load orders. Please try again.",
        downloading: "⬇️ Downloading {{format}} file...",
        downloaded: "✅ {{format}} file downloaded successfully",
        downloadFailed: "Download failed",
        downloadFailedRetry: "❌ Failed to download file. Please try again.",
        resourceDownloaded: "✅ {{fileName}} downloaded",
        resourceDownloadFailed: "❌ Failed to download resource",
        orderNumber: "Order #{{number}}",
        machine: "Machine",
        format: "Format",
        notSpecified: "Not specified",
        downloadFormats: "Download Formats",
        tokensUsed: "Tokens Used",
        chat: "Chat",
        extraResources: "Extra Resources ({{count}})",
        noneFound: "No orders found",
        tryAdjustFilters: "Try adjusting your filters",
        nonePlaced: "You haven't placed any orders yet"
      },
      myDesigns: {
        loading: "Loading your designs...",
        searchPlaceholder: "Search designs...",
        allStatus: "All Status",
        status: {
          draft: "Draft",
          ready: "Ready",
          processing: "Processing",
          completed: "Completed"
        },
        noneFound: "No designs found",
        tryAdjustFilters: "Try adjusting your filters",
        createFirst: "Create your first embroidery design",
        failedLoad: "Failed to load designs",
        failedLoadRetry: "❌ Failed to load designs. Please try again.",
        deletedSuccess: "✅ Design deleted successfully",
        failedDelete: "Failed to delete design",
        failedDeleteRetry: "❌ Failed to delete design. Please try again.",
        failedAddToCart: "Failed to add to cart",
        failedAddToCartRetry: "❌ Failed to add to cart. Please try again.",
        view: "View",
        addToCart: "Add to Cart",
        delete: "Delete",
        normalImage: "Normal Image",
        embroideryPreview: "Embroidery Preview",
        uploadedImage: "Uploaded Image",
        aiPrompt: "AI Prompt",
        style: "Style",
        tokensUsed: "Tokens Used",
        deleteDesign: "Delete Design",
        deleteConfirm: "Are you sure you want to delete \"{{name}}\"? This action cannot be undone.",
        cancel: "Cancel",
        deleting: "Deleting..."
      },
      tokenCost: {
        title: "Token Cost Management",
        subtitle: "Control how many tokens are deducted for each action in your system",
        loading: "Loading token costs...",
        failedLoad: "Failed to load token costs",
        failedLoadDefaults: "❌ Failed to load token costs. Using defaults.",
        updated: "✅ Token costs updated successfully",
        failedUpdate: "Failed to update token costs",
        failedUpdateRetry: "❌ Failed to update token costs",
        aiImageGeneration: "AI Image Generation",
        aiImageGenerationDesc: "Tokens spent when user generates AI images for designs",
        orderPlacement: "Order Placement",
        orderPlacementDesc: "Tokens spent when user places an order for digitization",
        welcomeTokens: "Welcome Tokens",
        welcomeTokensDesc: "Tokens granted to new users after successful verification",
        tokenCost: "Token Cost",
        changedFrom: "Changed from {{from}} → {{to}}",
        costSummary: "Cost Summary",
        resetChanges: "Reset Changes",
        noChanges: "No Changes",
        howItWorks: "How it works:",
        how1: "These token costs are deducted from user accounts when they perform actions",
        how2: "Adjust costs to control your token economy and user spending patterns",
        how3: "Users cannot perform actions if they don't have enough tokens",
        how4: "All changes take effect immediately across the system"
      },
      featureMgmt: {
        title: "Design Features Management",
        subtitle: "Create and manage premium features with token pricing",
        loading: "Loading features...",
        failedLoad: "Failed to load features",
        errorLoading: "Error loading features",
        createdSuccess: "Feature created successfully!",
        updatedSuccess: "Feature updated successfully!",
        failedCreate: "Failed to create feature",
        failedUpdate: "Failed to update feature",
        deletedSuccess: "Feature deleted successfully!",
        failedDelete: "Failed to delete feature",
        markedPopular: "Feature marked as popular!",
        unmarkedPopular: "Feature unmarked as popular!",
        failedPopularUpdate: "Failed to update popular status",
        createFeature: "Create Feature",
        allFeatures: "All Features ({{count}})",
        noneFound: "No features found",
        createFirst: "Create your first feature to get started",
        active: "Active",
        inactive: "Inactive",
        tokenCost: "Token Cost:",
        sortOrder: "Sort Order:",
        removePopular: "Remove from popular",
        markPopular: "Mark as popular",
        editFeature: "Edit feature",
        deleteFeature: "Delete feature",
        createNewFeature: "Create New Feature",
        featureName: "Feature Name",
        featureNamePlaceholder: "e.g., Text Customization",
        category: "Category",
        description: "Description",
        descriptionPlaceholder: "Describe what this feature does...",
        iconEmoji: "Icon Emoji",
        popularHint: "Popular (Show in featured list)",
        activeHint: "Active (Customers can see and use)",
        create: "Create",
        update: "Update",
        feature: "Feature",
        deleteFeatureQuestion: "Delete Feature?",
        deleteConfirm: "Are you sure you want to delete this feature? This action cannot be undone.",
        deleteNote: "Existing designs using this feature will be unaffected.",
        categories: {
          text: "Text Customization",
          color: "Color Options",
          effect: "Special Effects",
          quality: "Quality Enhancement",
          rush: "Rush Processing",
          support: "Premium Support"
        }
      },
      tokenMgmt: {
        title: "Token Package Management",
        subtitle: "Create and manage token packages for sale",
        loading: "Loading token packages...",
        failedLoad: "❌ Failed to load token packages",
        updatedSuccess: "✅ Package updated successfully",
        createdSuccess: "✅ Package created successfully",
        failedSave: "Failed to save package",
        failedSaveRetry: "❌ Failed to save package",
        deletedSuccess: "✅ Package deleted successfully",
        failedDelete: "Failed to delete package",
        failedDeleteRetry: "❌ Failed to delete package",
        popularUpdated: "✅ Popular status updated",
        failedUpdate: "Failed to update",
        failedPopularUpdate: "❌ Failed to update popular status",
        newPackage: "New Package",
        totalTokensSold: "Total Tokens Sold",
        totalPurchases: "Total Purchases",
        totalRevenue: "Total Revenue",
        searchPlaceholder: "Search packages...",
        package: "Package",
        price: "Price",
        savings: "Savings",
        purchases: "Purchases",
        revenue: "Revenue",
        actions: "Actions",
        noneFound: "No packages found",
        unmarkPopular: "Unmark as popular",
        markPopular: "Mark as popular",
        editPackage: "Edit Package",
        createPackage: "Create New Package",
        packageName: "Package Name",
        packageNamePlaceholder: "e.g., Starter Bundle",
        priceUsd: "Price (USD)",
        description: "Description",
        briefDescription: "Brief description",
        featuresComma: "Features (comma-separated)",
        featuresPlaceholder: "e.g., Priority support, Bulk discount, Fast processing",
        savingsPercentage: "Savings Percentage (%)",
        markMostPopular: "Mark as Most Popular",
        savePackage: "Save Package",
        deletePackageQuestion: "Delete Package?",
        deleteConfirm: "Are you sure you want to delete this package? This action cannot be undone."
      },
      sizePricing: {
        title: "Embroidery Size Pricing",
        subtitle: "Configure token prices based on embroidery size (5-40 cm)",
        failedLoad: "Failed to load pricing tiers",
        fillAllFields: "Please fill in all fields",
        addedSuccess: "✅ Pricing tier added: {{size}}cm = {{price}} tokens",
        failedAdd: "Failed to add tier",
        deleteConfirm: "Are you sure you want to delete this pricing tier?",
        deletedSuccess: "✅ Pricing tier deleted successfully",
        failedDelete: "Failed to delete tier",
        updatedSuccess: "✅ Pricing tier updated successfully",
        failedUpdate: "Failed to update tier",
        howItWorks: "How it works:",
        howItWorksDetail: "System automatically interpolates prices for sizes between your configured tiers.",
        example: "For example: 5cm = 10 tokens, 40cm = 30 tokens → 20cm = ~19 tokens (interpolated)",
        addNewTier: "Add New Pricing Tier",
        sizeCm: "Size (cm)",
        sizePlaceholder: "e.g. 5",
        priceTokens: "Price (tokens)",
        pricePlaceholder: "e.g. 10",
        adding: "Adding...",
        addTier: "Add Tier",
        currentTiers: "Current Pricing Tiers",
        tierCount: "({{count}} tiers)",
        noneConfigured: "No pricing tiers configured yet. Add your first tier above!",
        save: "Save",
        cancel: "Cancel",
        tokens: "tokens",
        edit: "Edit",
        deleting: "Deleting...",
        delete: "Delete"
      },
      chatContent: {
        conversationStarted: "✅ Conversation started!",
        failedCreateConversation: "Failed to create conversation",
        failedCreateConversationWithEmoji: "❌ Failed to create conversation",
        failedLoadConversation: "❌ Failed to load conversation",
        fileSizeLimit: "❌ File size must be less than 10MB",
        failedSend: "Failed to send message",
        failedSendWithEmoji: "❌ Failed to send message",
        messages: "Messages",
        noConversations: "No conversations yet",
        startChat: "Start Chat",
        newConversation: "New Conversation",
        unassigned: "Unassigned",
        noAdminAssigned: "No admin assigned",
        noMessages: "No messages yet. Start the conversation!",
        attachment: "attachment",
        file: "File",
        removeAttachment: "Remove attachment",
        attachFile: "Attach file",
        typeMessage: "Type your message...",
        selectConversation: "Select a conversation to start chatting",
        chooseOrder: "Choose an order from the list to view or start a conversation",
        startNewConversation: "Start New Conversation",
        selectOrderPrompt: "Select an order to start chatting with admin:",
        noOrders: "No orders yet",
        design: "Design",
        searchPlaceholder: "Search name, email or order",
        filterAll: "All",
        filterUnread: "Unread",
        filterUnassigned: "Unassigned",
        sortRecent: "Most recent",
        sortUnread: "Unread first",
        sortOldest: "Oldest first",
        noMatchingConversations: "No conversations match your filters",
        noMessagesYet: "No messages yet",
        you: "You",
        justNow: "Just now",
        minutesAgo: "{{count}} min",
        hoursAgo: "{{count}} h",
        today: "Today",
        yesterday: "Yesterday",
        read: "Read",
        delivered: "Delivered",
        back: "Back to conversations"
      },
      newDesign: {
        pleaseEnterPrompt: "❌ Please enter a prompt",
        generatedWithCost: "✅ Embroidery preview generated! Cost: {{cost}} tokens",
        generationFailed: "Generation failed",
        generationFailedRetry: "❌ Generation failed. Please try again.",
        uploadOrGenerateFirst: "❌ Upload or generate an image first",
        previewGenerated: "✅ Embroidery preview generated!",
        previewGenerationFailed: "Preview generation failed",
        previewGenerationFailedRetry: "❌ Preview generation failed. Please try again.",
        noDesignToSave: "⚠️ No design to save",
        designSaved: "✅ Design saved successfully!",
        saveFailed: "Save failed",
        saveFailedRetry: "❌ Save failed. Please try again.",
        noDesignToCart: "⚠️ No design to add to cart",
        failedSaveDesign: "Failed to save design",
        addedToCart: "✅ Added to cart!",
        failedAddToCart: "Failed to add to cart",
        failedAddToCartRetry: "❌ Failed to add to cart. Please try again.",
        canvasCleared: "✅ Canvas cleared",
        tabGenerateWithAi: "Generate with AI",
        tabMachineSettings: "Machine Settings",
        processing: "Processing your design...",
        embroideryPreviewAlt: "Embroidery Preview",
        embroideryPreview: "Embroidery Preview",
        generateWithAi: "Generate with AI",
        enterPrompt: "Enter your prompt to generate an image",
        reviewAndConfigure: "Review your design and configure machine settings",
        generateFirstToPreview: "Generate an image first to view preview",
        aiGeneration: "AI Generation",
        prompt: "Prompt",
        describePlaceholder: "Describe what you want to create...",
        generating: "Generating...",
        retryWithTokens: "Retry ({{count}} Tokens)",
        generateWithTokens: "Generate ({{count}} Tokens)",
        machineSettings: "Machine Settings",
        machineBrand: "Machine Brand",
        fileFormat: "File Format",
        selectFormatSupport: "Select the file format your {{brand}} machine supports",
        embroiderySize: "Embroidery Size",
        sizeCm: "{{size}} cm",
        sizeCostHint: "Affects the cost of embroidery. Larger sizes cost more tokens.",
        saveDesign: "Save Design",
        next: "Next",
        addToCart: "Add to Cart",
        clear: "Clear"
      },
      adminDashboard: {
        failedLoadOrders: "Failed to load orders",
        failedLoadOrdersRetry: "❌ Failed to load orders. Please try again.",
        failedLoadOrderDetails: "❌ Failed to load order details.",
        orderStatusUpdated: "✅ Order status updated successfully",
        failedUpdateStatus: "Failed to update status",
        failedUpdateStatusShort: "❌ Failed to update status.",
        selectAtLeastOneFile: "❌ Please select at least one file",
        mustUploadRequestedFormat: "❌ You must upload a file in the requested format: {{format}}. Other formats are not required.",
        onlyRequestedNeeded: "⚠️ Only the requested format ({{format}}) is needed. Extra formats will be ignored.",
        filesUploaded: "✅ Files uploaded successfully",
        failedUploadFiles: "Failed to upload files",
        failedUploadFilesRetry: "❌ Failed to upload files. Please try again.",
        failedUploadResources: "Failed to upload resources",
        failedUploadResourcesShort: "❌ Failed to upload resources.",
        deleteResourceConfirm: "Are you sure you want to delete this resource?",
        resourceDeleted: "✅ Resource deleted",
        failedDeleteResource: "❌ Failed to delete resource.",
        updatingOrderStatus: "Updating order status...",
        uploadingFiles: "Uploading files...",
        loadingOrders: "Loading orders...",
        title: "Admin Dashboard",
        tabOrders: "Orders",
        tabTokenPricing: "Token Pricing",
        tabTokenCosts: "Token Costs",
        tabSizePricing: "Size Pricing",
        tabBlog: "Blog",
        tabUsers: "Users",
        subtitle: "Manage and process embroidery digitization orders",
        searchPlaceholder: "Search by Order ID, Design, or User...",
        allOrders: "All Orders",
        submitted: "Submitted",
        orderCount_one: "{{count}} Order",
        orderCount_other: "{{count}} Orders",
        noOrders: "No orders found",
        tryAdjustSearch: "Try adjusting your search",
        ordersAppearHint: "Orders will appear here once submitted",
        orderId: "Order ID",
        design: "Design",
        user: "User",
        date: "Date",
        status: "Status",
        actions: "Actions",
        untitledDesign: "Untitled Design",
        viewDetails: "View Details",
        orderNumber: "Order #{{id}}",
        orderStatus: "Order Status",
        orderCost: "💰 Order Cost",
        embroiderySize: "Embroidery Size",
        sizeCm: "{{size}} cm",
        tokensUsed: "Tokens Used",
        tokensCount: "{{count}} tokens",
        machineSettingsCustomer: "⚙️ Machine Settings (Customer Selected)",
        notSpecified: "Not specified",
        requestedFormat: "Requested Format",
        customerInfo: "Customer Information",
        name: "Name",
        email: "Email",
        designInfo: "Design Information",
        designPreview: "Design Preview",
        image: "Image",
        designImage: "Design Image",
        designName: "Design Name",
        untitled: "Untitled",
        aiStyle: "AI Style",
        designDimensionsCanvas: "📐 Design Dimensions & Canvas",
        designSizeMm: "Design Size (mm)",
        hoopSize: "Hoop Size",
        canvasPx: "Canvas (px)",
        rotation: "Rotation",
        mirrored: "Mirrored",
        productionChecklist: "✓ Production Checklist",
        checkReviewSpecs: "Review all design specifications above",
        checkApplyThreadColors: "Apply {{count}} thread color(s) as specified",
        checkUseStitchDensity: "Use stitch density: {{density}}",
        high: "High",
        checkAddTextLayer: "Add text layer: \"{{text}}\"",
        checkDigitizeFormats: "Digitize all {{count}} requested formats",
        checkUploadAndComplete: "Upload files and mark order as \"completed\"",
        requestedFileFormats: "Requested File Formats",
        noSpecificFormats: "No specific formats requested (default: DST, PES, JEF)",
        uploadEmbroideryFiles: "Upload Embroidery Files",
        chatWithCustomer: "Chat with Customer",
        addResources: "Add Resources",
        extraResources: "Extra Resources ({{count}})",
        deleteResource: "Delete resource",
        uploadedFiles: "Uploaded Files",
        uploadRequestedFormatHint: "Upload the embroidery file in the customer's requested format:",
        customerRequestedFormatRequired: "🎯 Customer's Requested Format (Required):",
        uploadFormatFile: "Upload {{format}} File",
        important: "Important",
        onlyRequestedToComplete: "Only the requested format ({{format}}) is required. Upload only this format to complete the order.",
        adminNotesOptional: "Admin Notes (Optional)",
        adminNotesPlaceholder: "Add any notes about this order...",
        cancel: "Cancel",
        uploading: "Uploading...",
        uploadFiles: "Upload Files",
        resourcesHintPrefix: "📁 Upload extra files for the customer. These are",
        optional: "optional",
        resourcesHintSuffix: "and not required for order completion.",
        selectFiles: "Select Files",
        descriptionOptional: "Description (Optional)",
        resourceDescriptionPlaceholder: "e.g. Color chart, reference images...",
        uploadResources: "Upload Resources"
      },
      signup: {
        title: "Create your account",
        subtitle: "Start digitizing your embroidery designs today",
        agreeTermsError: "⚠️ Please agree to the Terms and Privacy Policy",
        passwordMismatch: "⚠️ Passwords do not match",
        success: "✅ Registration successful! Please check your email to verify your account.",
        registrationFailed: "Registration failed",
        genericError: "❌ An error occurred. Please try again.",
        oauthSoon: "sign-up coming soon!",
        googleAuthFailed: "Google sign-in failed. Please try again.",
        googleConfigMissing: "Google sign-in is not configured.",
        fullName: "Full Name",
        fullNamePlaceholder: "John Doe",
        email: "Email address",
        emailPlaceholder: "you@example.com",
        password: "Password",
        passwordHint: "Must be at least 8 characters long",
        confirmPassword: "Confirm Password",
        agreeTo: "I agree to the",
        terms: "Terms",
        and: "and",
        privacy: "Privacy Policy",
        creating: "Creating Account...",
        createAccount: "Create Account",
        orSignUpWith: "Or sign up with",
        alreadyHaveAccount: "Already have an account? ",
        signIn: "Sign in"
      },
      forgotPassword: {
        title: "Forgot Password?",
        subtitle: "Enter your email and we'll send you a reset link",
        email: "Email address",
        emailPlaceholder: "you@example.com",
        sending: "Sending...",
        sendResetLink: "Send Reset Link",
        backToSignIn: "Back to Sign In",
        checkEmail: "Check Your Email",
        sentMessage: "If your email exists, you will receive a reset link shortly.",
        failedSend: "Failed to send reset email",
        networkError: "Network error. Please try again."
      },
      resetPassword: {
        title: "Reset Your Password",
        subtitle: "Enter your new password below",
        newPassword: "New Password",
        newPasswordPlaceholder: "Enter new password",
        confirmPassword: "Confirm Password",
        confirmPasswordPlaceholder: "Confirm new password",
        resetPassword: "Reset Password",
        resetting: "Resetting...",
        passwordLength: "Password must be at least 8 characters",
        passwordMismatch: "Passwords do not match",
        invalidLink: "Invalid reset link",
        successTitle: "Password Reset Successfully!",
        successMessage: "Your password has been reset successfully.",
        resetFailed: "Failed to reset password",
        networkError: "Network error. Please try again.",
        redirecting: "Redirecting to login..."
      },
      verifyEmail: {
        verifyingTitle: "Verifying Your Email",
        verifyingSubtitle: "Please wait while we verify your email address...",
        successTitle: "Email Verified! 🎉",
        successMessage: "Your email has been verified.",
        welcome: "Welcome, {{username}}!",
        tokensInfo: "You have {{tokens}} tokens to start creating.",
        redirecting: "Redirecting you to the app...",
        failedTitle: "Verification Failed",
        failedMessage: "Email verification failed.",
        invalidLink: "Invalid verification link",
        networkError: "Failed to verify email. Please try again.",
        returnLogin: "Return to Login"
      },
      paymentSuccess: {
        verifyingTitle: "Verifying Payment...",
        verifyingSubtitle: "Please wait while we confirm your purchase",
        noSessionId: "No session ID found",
        verifyFailed: "Payment verification failed",
        verifyError: "Error verifying payment",
        errorTitle: "Payment Error",
        returnToApp: "Return to App",
        title: "Payment Successful!",
        subtitle: "Your tokens have been added to your account",
        tokenBalance: "Your Token Balance",
        tokens: "tokens",
        whatCanDo: "What you can do with your tokens:",
        aiImages: "🎨 Generate AI images: {{count}} tokens",
        placeOrder: "📥 Place an order: {{count}} tokens",
        startCreating: "Start Creating Designs"
      },
      paymentCancel: {
        title: "Payment Cancelled",
        subtitle: "Your payment was cancelled. No charges were made to your account.",
        whatHappened: "What happened?",
        details: "You can safely close the payment window at any time. If you experienced any issues during checkout, please try again or contact our support team.",
        tryAgain: "Try Again",
        backToDashboard: "Back to Dashboard",
        needHelp: "Need help?",
        contactSupport: "Contact Support"
      },
      signin: {
        title: "Welcome back",
        subtitle: "Sign in to your account to continue creating",
        loginSuccess: "✅ Login successful! Redirecting...",
        invalidCredentials: "Invalid credentials",
        genericError: "❌ An error occurred. Please try again.",
        verificationSent: "✅ Verification email sent! Please check your inbox.",
        failedResend: "Failed to resend email",
        oauthSoon: "sign-in coming soon!",
        googleAuthFailed: "Google sign-in failed. Please try again.",
        googleConfigMissing: "Google sign-in is not configured.",
        resendVerification: "Click here to resend verification email",
        emailOrUsername: "Email or Username",
        emailPlaceholder: "email@example.com or username",
        password: "Password",
        hidePassword: "Hide password",
        showPassword: "Show password",
        rememberMe: "Remember me",
        forgotPassword: "Forgot your password?",
        signingIn: "Signing In...",
        signIn: "Sign in",
        orContinueWith: "Or continue with",
        noAccount: "Don't have an account? ",
        signUpFree: "Sign up for free"
      },
      dashboard: {
        loading: "Loading...",
        titleNewDesign: "New Design",
        titleDashboard: "dashboard",
        titleCart: "cart",
        titleOrders: "orders",
        titleTokens: "tokens",
        titleSettings: "settings",
        titleMessages: "messages",
        titleAdmin: "admin",
        navAdmin: "Admin Panel",
        navNewDesign: "New Design",
        navMyDesigns: "My Designs",
        navCart: "Cart",
        navOrders: "Orders",
        navMessages: "Messages",
        navBuyTokens: "Buy Tokens",
        navSettings: "Settings",
        navHowItWorks: "How It Works",
        titleHowItWorks: "How It Works",
        tokenLabel: "Tokens",
        tokenLeft: "{{count}} left",
        topup: "Top up balance",
        signOut: "Sign Out",
        proPlan: "Pro Plan",
        cartTitle: "Cart"
      },
      howItWorks: {
        heroBadge: "Simple & Easy",
        heroTitle: "How It Works",
        heroSubtitle: "Transform your ideas into professional embroidery files in just a few simple steps. Our AI-powered platform makes it easy for everyone.",
        step1Title: "Describe Your Design",
        step1Desc: "Tell our AI what you want — describe your embroidery design idea in words, choose your style, and let the magic begin.",
        step2Title: "AI Generates Your Design",
        step2Desc: "Our advanced AI creates a beautiful embroidery-ready design based on your description. Preview it instantly and make adjustments.",
        step3Title: "Add to Cart",
        step3Desc: "Happy with your design? Add it to your cart. You can customize the embroidery size and select your preferred machine format.",
        step4Title: "Checkout with Tokens",
        step4Desc: "Use your tokens to place the order. Our professional digitizers will convert your design into a real embroidery file.",
        step5Title: "Download Your Files",
        step5Desc: "Once digitized, download your embroidery files in your chosen format — ready to load onto your embroidery machine and stitch!",
        tipsTitle: "Pro Tips",
        tip1: "Be specific in your design descriptions for the best AI results — mention colors, style, and details.",
        tip2: "Check our token packages for the best value — larger packages offer bonus tokens!",
        tip3: "You can order multiple formats for the same design to use on different embroidery machines.",
        ctaTitle: "Ready to Create?",
        ctaDesc: "Start designing your custom embroidery files with the power of AI. It only takes a few minutes!",
        ctaButton: "Create My Design"
      },
      landing: {
        login: "Log In",
        getStarted: "Get Started",
        heroBadge: "AI-Powered Embroidery Digitizing",
        heroTitle1: "Transform Ideas Into",
        heroHighlight: "Embroidery Files",
        heroTitle2: "With AI",
        heroSubtitle: "Describe your design, and our AI generates professional embroidery-ready files for any machine. Support for 21+ formats and 17 brands — from concept to stitch in minutes.",
        heroCtaPrimary: "Start Creating Free",
        heroCtaSecondary: "See How It Works",
        statFormats: "File Formats",
        statBrands: "Machine Brands",
        statFreeTokens: "Free Tokens on Signup",
        brandsLabel: "Compatible with all major embroidery machine brands",
        howTag: "How It Works",
        howTitle: "From Idea to Embroidery in 3 Steps",
        howDesc: "No design skills needed. Our AI and professional digitizers handle the technical work for you.",
        step1Title: "Describe Your Design",
        step1Desc: "Type a prompt describing what you want — a floral pattern, a logo, custom text — or upload your own image.",
        step2Title: "AI Generates Your Preview",
        step2Desc: "Our AI transforms your idea into an embroidery-style preview. Choose your machine brand, format, and size.",
        step3Title: "Download Machine-Ready Files",
        step3Desc: "Professional digitizers convert your design into stitch files. Download in PES, DST, JEF, and 18+ other formats.",
        featTag: "Why Choose Us",
        featTitle: "Everything You Need for Embroidery",
        featDesc: "Professional tools and AI technology combined to deliver the best embroidery digitizing experience.",
        feat1Title: "AI-Powered Design",
        feat1Desc: "Generate unique embroidery designs from text descriptions using advanced AI image generation.",
        feat2Title: "21+ File Formats",
        feat2Desc: "PES, DST, JEF, EXP, VP3, HUS, and more. Every major embroidery format supported out of the box.",
        feat3Title: "Fast Turnaround",
        feat3Desc: "AI previews are generated instantly. Professional digitization is completed quickly by expert digitizers.",
        feat4Title: "Secure Payments",
        feat4Desc: "Token-based pricing with Stripe-protected transactions. Buy only what you need, no subscriptions required.",
        feat5Title: "Multi-Language",
        feat5Desc: "Full English and French support. Use the platform in your preferred language with complete translations.",
        feat6Title: "Expert Support",
        feat6Desc: "Built-in chat system for direct communication with our digitizing team on every order.",
        ctaTitle: "Ready to Bring Your Designs to Life?",
        ctaDesc: "Join now and start creating professional embroidery files with AI.",
        ctaButton: "Create Your Free Account",
        ctaBonus: "Free tokens on signup — no credit card required",
        footerRights: "All rights reserved.",
        footerHome: "Home",
        footerAbout: "About",
        footerPrivacy: "Privacy"
      },
      privacy: {
        heroTitle: "Privacy Policy",
        heroDesc: "How we collect, use, and protect your personal information.",
        tocTitle: "Contents",
        collectTitle: "Information We Collect",
        collectIntro: "We collect information you provide directly and data generated through your use of our service:",
        collectAccount: "Account information",
        collectAccountDesc: "Name, email address, and password when you create an account, or profile data from Google when you sign in with OAuth.",
        collectDesign: "Design data",
        collectDesignDesc: "Images you upload and embroidery files we generate, along with settings such as size, format, and stitch density.",
        collectPayment: "Payment information",
        collectPaymentDesc: "Billing details processed securely through Stripe. We never store your full card number on our servers.",
        collectTechnical: "Technical data",
        collectTechnicalDesc: "IP address, browser type, device information, and usage logs collected automatically for security and analytics.",
        useTitle: "How We Use Your Data",
        useIntro: "Your information is used to:",
        use1: "Provide and maintain the embroidery file conversion service.",
        use2: "Process orders and manage your token balance.",
        use3: "Communicate with you about your account or orders.",
        use4: "Improve our AI models and service quality.",
        use5: "Prevent fraud and ensure platform security.",
        cookiesTitle: "Cookies",
        cookiesIntro: "We use a limited number of cookies strictly necessary for the service to function:",
        cookiesEssential: "Session cookies",
        cookiesEssentialDesc: "Keep you signed in and remember your preferences during a session.",
        cookiesAuth: "Authentication tokens",
        cookiesAuthDesc: "Securely verify your identity on each request.",
        cookiesNote: "We do not use advertising or tracking cookies. No third-party analytics cookies are set.",
        thirdTitle: "Third-Party Services",
        thirdIntro: "We share data with the following providers solely to deliver our service:",
        thirdStripe: "Secure payment processing. Subject to Stripe's privacy policy.",
        thirdOpenai: "Image analysis for embroidery digitization. Images are processed per OpenAI's data usage policy.",
        thirdGoogle: "Optional sign-in authentication. Only basic profile info (name, email, avatar) is retrieved.",
        thirdNoSell: "We never sell your personal data to any third party.",
        rightsTitle: "Your Rights",
        rightsIntro: "Under applicable data protection regulations (including GDPR), you have the right to:",
        rights1: "Access the personal data we hold about you.",
        rights2: "Correct inaccurate or incomplete data.",
        rights3: "Request deletion of your account and associated data.",
        rights4: "Export your data in a portable format.",
        rights5: "Withdraw consent at any time by contacting us.",
        securityTitle: "Security",
        securityDesc: "We protect your data with HTTPS encryption in transit, hashed passwords, and secure server infrastructure hosted within the EU. Access to personal data is restricted to authorized personnel only.",
        retentionTitle: "Data Retention",
        retentionDesc: "Account data is retained as long as your account is active. Uploaded images and generated files are stored for up to 90 days after the last order, then permanently deleted. You may request earlier deletion at any time.",
        contactTitle: "Contact Us",
        contactDesc: "For any privacy-related questions or requests, please email us at contact@aiembroideryfiles.com. We aim to respond within 48 hours.",
        lastUpdated: "Last updated: June 2025"
      },
      about: {
        heroTitle: "About Us",
        heroDesc: "We're building the future of embroidery digitization — powered by AI, crafted for creators.",
        missionTag: "Our Mission",
        missionTitle: "Making Professional Embroidery Accessible to Everyone",
        missionDesc: "Traditional embroidery digitization is slow, expensive, and limited to specialists. We combine artificial intelligence with deep knowledge of machine embroidery to deliver production-ready files in minutes — not days. Whether you run a small craft business or a large production workshop, our platform gives you professional results at a fraction of the cost.",
        card1Title: "AI-Powered Digitization",
        card1Desc: "Upload any image and our AI analyzes colors, shapes, and textures to generate optimized embroidery files tailored to your machine.",
        card2Title: "21+ Output Formats",
        card2Desc: "From DST and PES to JEF, VP3, and more — we support all major embroidery machine formats so you can work with the equipment you have.",
        card3Title: "Instant Delivery",
        card3Desc: "No waiting days for a digitizer to respond. Get your embroidery files generated and ready to download within minutes.",
        statFormats: "Output Formats",
        statBrands: "Machine Brands",
        statLanguages: "Languages",
        statAvailability: "Availability",
        valuesTitle: "Our Values",
        val1Title: "Passion for Craft",
        val1Desc: "We love embroidery and understand the care that goes into every stitch.",
        val2Title: "Precision First",
        val2Desc: "Every file is optimized for clean stitching, proper density, and accurate colors.",
        val3Title: "Transparency",
        val3Desc: "Clear pricing with a token system — no hidden fees, no subscriptions required.",
        val4Title: "Trust & Privacy",
        val4Desc: "Your designs stay yours. We never share or reuse your uploaded images.",
        ctaTitle: "Ready to Try It?",
        ctaDesc: "Create your free account and start converting images into embroidery files today.",
        ctaButton: "Get Started Free"
      },
      blog: {
        navTitle: "Blog",
        heroTitle: "Our Blog",
        heroDesc: "Tips, tutorials, and news about embroidery digitization and our platform.",
        readMore: "Read more",
        prev: "Previous",
        next: "Next",
        emptyTitle: "No Posts Yet",
        emptyDesc: "We're working on great content. Check back soon!",
        notFound: "Post Not Found",
        notFoundDesc: "This blog post doesn't exist or has been removed.",
        backToList: "Back to Blog"
      },
      blogAdmin: {
        subtitle: "Create and manage blog posts.",
        newPost: "New Post",
        editPost: "Edit Post",
        back: "Back",
        titleLabel: "Title",
        titlePlaceholder: "Enter post title...",
        excerptLabel: "Excerpt",
        excerptPlaceholder: "Short summary shown on the blog list...",
        coverLabel: "Cover Image",
        chooseCover: "Choose Image",
        contentLabel: "Content",
        contentPlaceholder: "Write your blog post here...",
        metaLabel: "Meta Description",
        metaPlaceholder: "SEO description for search engines...",
        draft: "Draft",
        published: "Published",
        publish: "Publish",
        unpublish: "Unpublish",
        save: "Save",
        saving: "Saving...",
        created: "Post created successfully.",
        updated: "Post updated successfully.",
        deleted: "Post deleted.",
        titleRequired: "\u274c Title is required.",
        loadError: "\u274c Failed to load posts.",
        saveError: "\u274c Failed to save post.",
        deleteError: "\u274c Failed to delete post.",
        confirmDelete: "Are you sure you want to delete this post?",
        noPosts: "No blog posts yet. Click \"New Post\" to create one."
      },
      userManagement: {
        title: "User Management",
        searchPlaceholder: "Search by name, email, or username...",
        search: "Search",
        username: "Username",
        email: "Email",
        name: "Name",
        tokens: "Tokens",
        verified: "Verified",
        staff: "Staff",
        active: "Active",
        joined: "Joined",
        actions: "Actions",
        firstName: "First name",
        lastName: "Last name",
        edit: "Edit",
        delete: "Delete",
        save: "Save",
        cancel: "Cancel",
        confirmDelete: "Confirm?",
        userUpdated: "User updated successfully.",
        userDeleted: "User deleted successfully.",
        loadError: "Failed to load users.",
        updateError: "Failed to update user.",
        deleteError: "Failed to delete user.",
        noUsers: "No users found.",
        totalUsers: "Total users",
        resetPwd: "Reset Pwd",
        resetPassword: "Reset Password",
        resetPasswordDesc: "Set a new password for {{username}}.",
        newPassword: "New password (min. 8 characters)",
        passwordReset: "Password reset successfully.",
        passwordResetError: "Failed to reset password.",
        passwordMinLength: "Password must be at least 8 characters.",
        saving: "Saving..."
      }
    }
  },
  fr: {
    translation: {
      common: {
        loading: "Chargement...",
        na: "N/A"
      },
      buyTokens: {
        title: "Acheter des jetons",
        tokensPerDesign: "{{count}} jetons par design",
        failedLoadPackages: "Échec du chargement des packs de jetons",
        noCheckoutUrl: "Aucune URL de paiement reçue",
        failedCheckout: "Échec du démarrage du paiement",
        whyBuy: "Pourquoi acheter des jetons ?",
        mostPopular: "LE PLUS POPULAIRE",
        tokens: "Jetons",
        processing: "Traitement...",
        buyNow: "Acheter maintenant",
        featureInstantTitle: "Livraison instantanée",
        featureInstantDesc: "Jetons crédités immédiatement sur votre compte",
        featureSecureTitle: "Paiement sécurisé",
        featureFlexibleTitle: "Options flexibles",
        featureFlexibleDesc: "Plusieurs tailles de packs au choix",
        featureEmailTitle: "Notifications email",
        featureEmailDesc: "Confirmations et mises à jour instantanées",
        choosePayment: "Choisir le mode de paiement",
        payWithCard: "Payer par carte",
        payWithPayPal: "Payer avec PayPal",
        featureSecureDesc: "Protégé par le chiffrement sécurisé Stripe et PayPal"
      },
      cart: {
        processingOrder: "Traitement de la commande...",
        loadingCart: "Chargement du panier...",
        title: "Panier",
        empty: "Votre panier est vide",
        itemCount_one: "{{count}} article dans votre panier",
        itemCount_other: "{{count}} articles dans votre panier",
        addDesignsHint: "Ajoutez des designs à votre panier pour commencer à commander",
        createDesign: "Créer un design",
        removeFromCart: "Retirer du panier",
        orderSummary: "Récapitulatif",
        items: "Articles ({{count}})",
        total: "Total",
        yourBalance: "Votre solde",
        insufficientTokens: "Jetons insuffisants",
        embroideryFormat: "Format de broderie",
        autoFromMachine: "Sélection automatique selon les réglages machine",
        formatFromMachine: "Le format sera pris depuis vos réglages machine",
        selectFileFormats: "Sélectionner les formats de fichier",
        selectedFormats_one: "{{count}} format sélectionné",
        selectedFormats_other: "{{count}} formats sélectionnés",
        doneSelected: "Terminé ({{count}} sélectionné(s))",
        placingOrder: "Validation de la commande...",
        placeOrder: "Passer la commande",
        buyMoreTokens: "Acheter plus de jetons",
        continueShopping: "Continuer vos achats",
        quantity: "Quantité : 1",
        untitledDesign: "Design sans titre",
        failedLoadCart: "Échec du chargement du panier",
        failedLoadCartRetry: "❌ Échec du chargement du panier. Veuillez réessayer.",
        removedSuccess: "✅ Article retiré du panier",
        failedRemove: "Échec de suppression de l'article",
        failedRemoveRetry: "❌ Échec de suppression de l'article. Veuillez réessayer.",
        insufficientTokensMessage: "❌ Jetons insuffisants. Veuillez en acheter davantage.",
        placedSuccess: "✅ Commande passée avec succès !",
        failedPlaceOrder: "Échec de la commande",
        failedPlaceOrderRetry: "❌ Échec de la commande. Veuillez réessayer.",
        designSize: "Taille du design",
        fileFormat: "Format de fichier",
        failedUpdate: "Échec de la mise à jour de l'article",
        failedUpdateRetry: "Échec de la mise à jour. Veuillez réessayer."
      },
      settings: {
        title: "Paramètres",
        subtitle: "Gérez votre compte",
        profileStats: "Statistiques du profil",
        totalDesigns: "Designs totaux",
        totalOrders: "Commandes totales",
        tokenBalance: "Solde de jetons",
        memberSince: "Membre depuis",
        profileInfo: "Informations du profil",
        verified: "✓ Vérifié",
        unverified: "⚠ Non vérifié",
        firstName: "Prénom",
        lastName: "Nom",
        emailAddress: "Adresse email",
        saving: "Enregistrement...",
        saveChanges: "Enregistrer les modifications",
        changePassword: "Changer le mot de passe",
        currentPassword: "Mot de passe actuel",
        newPassword: "Nouveau mot de passe",
        confirmNewPassword: "Confirmer le nouveau mot de passe",
        updating: "Mise à jour...",
        updatePassword: "Mettre à jour le mot de passe",
        transactionHistory: "Historique des transactions de jetons",
        noTransactions: "Aucune transaction pour le moment",
        date: "Date",
        type: "Type",
        amount: "Montant",
        description: "Description",
        balanceAfter: "Solde après",
        accountActions: "Actions du compte",
        signOut: "Déconnexion",
        failedLoadProfile: "Échec du chargement du profil",
        failedLoadProfileRetry: "❌ Échec du chargement du profil. Veuillez réessayer.",
        profileUpdated: "✅ Profil mis à jour avec succès",
        failedUpdateProfile: "Échec de la mise à jour du profil",
        failedUpdateProfileRetry: "❌ Échec de la mise à jour du profil. Veuillez réessayer.",
        passwordsNoMatch: "❌ Les nouveaux mots de passe ne correspondent pas",
        passwordChanged: "✅ Mot de passe modifié avec succès",
        failedChangePassword: "Échec du changement de mot de passe",
        failedChangePasswordRetry: "❌ Échec du changement de mot de passe. Veuillez réessayer."
      },
      orders: {
        title: "Commandes",
        searchPlaceholder: "Rechercher des commandes...",
        allStatus: "Tous les statuts",
        status: {
          pending_payment: "Paiement en attente",
          processing: "En traitement",
          completed: "Terminé",
          failed: "Échoué",
          cancelled: "Annulé"
        },
        failedLoad: "Échec du chargement des commandes",
        failedLoadRetry: "❌ Échec du chargement des commandes. Veuillez réessayer.",
        downloading: "⬇️ Téléchargement du fichier {{format}}...",
        downloaded: "✅ Fichier {{format}} téléchargé avec succès",
        downloadFailed: "Échec du téléchargement",
        downloadFailedRetry: "❌ Échec du téléchargement. Veuillez réessayer.",
        resourceDownloaded: "✅ {{fileName}} téléchargé",
        resourceDownloadFailed: "❌ Échec du téléchargement de la ressource",
        orderNumber: "Commande #{{number}}",
        machine: "Machine",
        format: "Format",
        notSpecified: "Non spécifié",
        downloadFormats: "Formats téléchargeables",
        tokensUsed: "Jetons utilisés",
        chat: "Chat",
        extraResources: "Ressources supplémentaires ({{count}})",
        noneFound: "Aucune commande trouvée",
        tryAdjustFilters: "Essayez d'ajuster vos filtres",
        nonePlaced: "Vous n'avez pas encore passé de commande"
      },
      myDesigns: {
        loading: "Chargement de vos designs...",
        searchPlaceholder: "Rechercher des designs...",
        allStatus: "Tous les statuts",
        status: {
          draft: "Brouillon",
          ready: "Prêt",
          processing: "En traitement",
          completed: "Terminé"
        },
        noneFound: "Aucun design trouvé",
        tryAdjustFilters: "Essayez d'ajuster vos filtres",
        createFirst: "Créez votre premier design de broderie",
        failedLoad: "Échec du chargement des designs",
        failedLoadRetry: "❌ Échec du chargement des designs. Veuillez réessayer.",
        deletedSuccess: "✅ Design supprimé avec succès",
        failedDelete: "Échec de la suppression du design",
        failedDeleteRetry: "❌ Échec de la suppression du design. Veuillez réessayer.",
        failedAddToCart: "Échec de l'ajout au panier",
        failedAddToCartRetry: "❌ Échec de l'ajout au panier. Veuillez réessayer.",
        view: "Voir",
        addToCart: "Ajouter au panier",
        delete: "Supprimer",
        normalImage: "Image normale",
        embroideryPreview: "Aperçu broderie",
        uploadedImage: "Image importée",
        aiPrompt: "Prompt IA",
        style: "Style",
        tokensUsed: "Jetons utilisés",
        deleteDesign: "Supprimer le design",
        deleteConfirm: "Voulez-vous vraiment supprimer \"{{name}}\" ? Cette action est irréversible.",
        cancel: "Annuler",
        deleting: "Suppression..."
      },
      tokenCost: {
        title: "Gestion du coût des jetons",
        subtitle: "Contrôlez le nombre de jetons déduits pour chaque action de votre système",
        loading: "Chargement des coûts de jetons...",
        failedLoad: "Échec du chargement des coûts de jetons",
        failedLoadDefaults: "❌ Échec du chargement des coûts de jetons. Valeurs par défaut utilisées.",
        updated: "✅ Coûts de jetons mis à jour avec succès",
        failedUpdate: "Échec de la mise à jour des coûts de jetons",
        failedUpdateRetry: "❌ Échec de la mise à jour des coûts de jetons",
        aiImageGeneration: "Génération d'image IA",
        aiImageGenerationDesc: "Jetons dépensés quand l'utilisateur génère des images IA",
        orderPlacement: "Passage de commande",
        orderPlacementDesc: "Jetons dépensés quand l'utilisateur passe une commande de digitalisation",
        welcomeTokens: "Jetons de bienvenue",
        welcomeTokensDesc: "Jetons attribués aux nouveaux utilisateurs après vérification réussie",
        tokenCost: "Coût en jetons",
        changedFrom: "Modifié de {{from}} → {{to}}",
        costSummary: "Résumé des coûts",
        resetChanges: "Réinitialiser les modifications",
        noChanges: "Aucun changement",
        howItWorks: "Comment ça marche :",
        how1: "Ces coûts en jetons sont déduits des comptes utilisateurs lors des actions",
        how2: "Ajustez les coûts pour contrôler votre économie de jetons",
        how3: "Les utilisateurs ne peuvent pas agir s'ils n'ont pas assez de jetons",
        how4: "Toutes les modifications prennent effet immédiatement dans le système"
      },
      featureMgmt: {
        title: "Gestion des fonctionnalités de design",
        subtitle: "Créez et gérez des fonctionnalités premium avec tarification en jetons",
        loading: "Chargement des fonctionnalités...",
        failedLoad: "Échec du chargement des fonctionnalités",
        errorLoading: "Erreur lors du chargement des fonctionnalités",
        createdSuccess: "Fonctionnalité créée avec succès !",
        updatedSuccess: "Fonctionnalité mise à jour avec succès !",
        failedCreate: "Échec de création de la fonctionnalité",
        failedUpdate: "Échec de mise à jour de la fonctionnalité",
        deletedSuccess: "Fonctionnalité supprimée avec succès !",
        failedDelete: "Échec de suppression de la fonctionnalité",
        markedPopular: "Fonctionnalité marquée populaire !",
        unmarkedPopular: "Fonctionnalité retirée des populaires !",
        failedPopularUpdate: "Échec de mise à jour du statut populaire",
        createFeature: "Créer une fonctionnalité",
        allFeatures: "Toutes les fonctionnalités ({{count}})",
        noneFound: "Aucune fonctionnalité trouvée",
        createFirst: "Créez votre première fonctionnalité pour commencer",
        active: "Actif",
        inactive: "Inactif",
        tokenCost: "Coût en jetons :",
        sortOrder: "Ordre de tri :",
        removePopular: "Retirer des populaires",
        markPopular: "Marquer comme populaire",
        editFeature: "Modifier la fonctionnalité",
        deleteFeature: "Supprimer la fonctionnalité",
        createNewFeature: "Créer une nouvelle fonctionnalité",
        featureName: "Nom de la fonctionnalité",
        featureNamePlaceholder: "ex. : Personnalisation du texte",
        category: "Catégorie",
        description: "Description",
        descriptionPlaceholder: "Décrivez ce que fait cette fonctionnalité...",
        iconEmoji: "Emoji icône",
        popularHint: "Populaire (Afficher dans la liste vedette)",
        activeHint: "Actif (Les clients peuvent voir et utiliser)",
        create: "Créer",
        update: "Mettre à jour",
        feature: "fonctionnalité",
        deleteFeatureQuestion: "Supprimer la fonctionnalité ?",
        deleteConfirm: "Voulez-vous vraiment supprimer cette fonctionnalité ? Cette action est irréversible.",
        deleteNote: "Les designs existants utilisant cette fonctionnalité ne seront pas affectés.",
        categories: {
          text: "Personnalisation du texte",
          color: "Options de couleur",
          effect: "Effets spéciaux",
          quality: "Amélioration de qualité",
          rush: "Traitement urgent",
          support: "Support premium"
        }
      },
      tokenMgmt: {
        title: "Gestion des packs de jetons",
        subtitle: "Créez et gérez les packs de jetons à vendre",
        loading: "Chargement des packs de jetons...",
        failedLoad: "❌ Échec du chargement des packs de jetons",
        updatedSuccess: "✅ Pack mis à jour avec succès",
        createdSuccess: "✅ Pack créé avec succès",
        failedSave: "Échec de l'enregistrement du pack",
        failedSaveRetry: "❌ Échec de l'enregistrement du pack",
        deletedSuccess: "✅ Pack supprimé avec succès",
        failedDelete: "Échec de la suppression du pack",
        failedDeleteRetry: "❌ Échec de la suppression du pack",
        popularUpdated: "✅ Statut populaire mis à jour",
        failedUpdate: "Échec de la mise à jour",
        failedPopularUpdate: "❌ Échec de la mise à jour du statut populaire",
        newPackage: "Nouveau pack",
        totalTokensSold: "Total des jetons vendus",
        totalPurchases: "Total des achats",
        totalRevenue: "Revenu total",
        searchPlaceholder: "Rechercher des packs...",
        package: "Pack",
        price: "Prix",
        savings: "Économies",
        purchases: "Achats",
        revenue: "Revenu",
        actions: "Actions",
        noneFound: "Aucun pack trouvé",
        unmarkPopular: "Retirer des populaires",
        markPopular: "Marquer comme populaire",
        editPackage: "Modifier le pack",
        createPackage: "Créer un nouveau pack",
        packageName: "Nom du pack",
        packageNamePlaceholder: "ex. : Pack démarrage",
        priceUsd: "Prix (USD)",
        description: "Description",
        briefDescription: "Brève description",
        featuresComma: "Fonctionnalités (séparées par des virgules)",
        featuresPlaceholder: "ex. : Support prioritaire, Remise volume, Traitement rapide",
        savingsPercentage: "Pourcentage d'économie (%)",
        markMostPopular: "Marquer comme le plus populaire",
        savePackage: "Enregistrer le pack",
        deletePackageQuestion: "Supprimer le pack ?",
        deleteConfirm: "Voulez-vous vraiment supprimer ce pack ? Cette action est irréversible."
      },
      sizePricing: {
        title: "Tarification par taille de broderie",
        subtitle: "Configurez les prix en jetons selon la taille de broderie (5-40 cm)",
        failedLoad: "Échec du chargement des paliers de prix",
        fillAllFields: "Veuillez remplir tous les champs",
        addedSuccess: "✅ Palier ajouté : {{size}}cm = {{price}} jetons",
        failedAdd: "Échec de l'ajout du palier",
        deleteConfirm: "Voulez-vous vraiment supprimer ce palier de prix ?",
        deletedSuccess: "✅ Palier de prix supprimé avec succès",
        failedDelete: "Échec de la suppression du palier",
        updatedSuccess: "✅ Palier de prix mis à jour avec succès",
        failedUpdate: "Échec de la mise à jour du palier",
        howItWorks: "Comment ça marche :",
        howItWorksDetail: "Le système interpole automatiquement les prix pour les tailles entre vos paliers configurés.",
        example: "Exemple : 5cm = 10 jetons, 40cm = 30 jetons → 20cm = ~19 jetons (interpolé)",
        addNewTier: "Ajouter un nouveau palier",
        sizeCm: "Taille (cm)",
        sizePlaceholder: "ex. : 5",
        priceTokens: "Prix (jetons)",
        pricePlaceholder: "ex. : 10",
        adding: "Ajout...",
        addTier: "Ajouter le palier",
        currentTiers: "Paliers de prix actuels",
        tierCount: "({{count}} paliers)",
        noneConfigured: "Aucun palier configuré pour le moment. Ajoutez votre premier palier ci-dessus !",
        save: "Enregistrer",
        cancel: "Annuler",
        tokens: "jetons",
        edit: "Modifier",
        deleting: "Suppression...",
        delete: "Supprimer"
      },
      chatContent: {
        conversationStarted: "✅ Conversation démarrée !",
        failedCreateConversation: "Échec de création de la conversation",
        failedCreateConversationWithEmoji: "❌ Échec de création de la conversation",
        failedLoadConversation: "❌ Échec du chargement de la conversation",
        fileSizeLimit: "❌ La taille du fichier doit être inférieure à 10 Mo",
        failedSend: "Échec de l'envoi du message",
        failedSendWithEmoji: "❌ Échec de l'envoi du message",
        messages: "Messages",
        noConversations: "Aucune conversation pour le moment",
        startChat: "Démarrer le chat",
        newConversation: "Nouvelle conversation",
        unassigned: "Non attribué",
        noAdminAssigned: "Aucun admin attribué",
        noMessages: "Aucun message pour le moment. Lancez la conversation !",
        attachment: "pièce jointe",
        file: "Fichier",
        removeAttachment: "Retirer la pièce jointe",
        attachFile: "Joindre un fichier",
        typeMessage: "Tapez votre message...",
        selectConversation: "Sélectionnez une conversation pour commencer à discuter",
        chooseOrder: "Choisissez une commande dans la liste pour voir ou démarrer une conversation",
        startNewConversation: "Démarrer une nouvelle conversation",
        selectOrderPrompt: "Sélectionnez une commande pour discuter avec l'admin :",
        noOrders: "Aucune commande pour le moment",
        design: "Design",
        searchPlaceholder: "Rechercher nom, e-mail ou commande",
        filterAll: "Toutes",
        filterUnread: "Non lues",
        filterUnassigned: "Non attribuées",
        sortRecent: "Plus récentes",
        sortUnread: "Non lues d'abord",
        sortOldest: "Plus anciennes",
        noMatchingConversations: "Aucune conversation ne correspond à vos filtres",
        noMessagesYet: "Aucun message pour le moment",
        you: "Vous",
        justNow: "À l'instant",
        minutesAgo: "{{count}} min",
        hoursAgo: "{{count}} h",
        today: "Aujourd'hui",
        yesterday: "Hier",
        read: "Lu",
        delivered: "Envoyé",
        back: "Retour aux conversations"
      },
      newDesign: {
        pleaseEnterPrompt: "❌ Veuillez saisir un prompt",
        generatedWithCost: "✅ Aperçu broderie généré ! Coût : {{cost}} jetons",
        generationFailed: "Échec de génération",
        generationFailedRetry: "❌ Échec de génération. Veuillez réessayer.",
        uploadOrGenerateFirst: "❌ Importez ou générez d'abord une image",
        previewGenerated: "✅ Aperçu broderie généré !",
        previewGenerationFailed: "Échec de génération de l'aperçu",
        previewGenerationFailedRetry: "❌ Échec de génération de l'aperçu. Veuillez réessayer.",
        noDesignToSave: "⚠️ Aucun design à enregistrer",
        designSaved: "✅ Design enregistré avec succès !",
        saveFailed: "Échec de l'enregistrement",
        saveFailedRetry: "❌ Échec de l'enregistrement. Veuillez réessayer.",
        noDesignToCart: "⚠️ Aucun design à ajouter au panier",
        failedSaveDesign: "Échec de l'enregistrement du design",
        addedToCart: "✅ Ajouté au panier !",
        failedAddToCart: "Échec de l'ajout au panier",
        failedAddToCartRetry: "❌ Échec de l'ajout au panier. Veuillez réessayer.",
        canvasCleared: "✅ Canevas effacé",
        tabGenerateWithAi: "Générer avec l'IA",
        tabMachineSettings: "Paramètres machine",
        processing: "Traitement de votre design...",
        embroideryPreviewAlt: "Aperçu broderie",
        embroideryPreview: "Aperçu broderie",
        generateWithAi: "Générer avec l'IA",
        enterPrompt: "Saisissez votre prompt pour générer une image",
        reviewAndConfigure: "Vérifiez votre design et configurez les paramètres machine",
        generateFirstToPreview: "Générez d'abord une image pour afficher l'aperçu",
        aiGeneration: "Génération IA",
        prompt: "Prompt",
        describePlaceholder: "Décrivez ce que vous voulez créer...",
        generating: "Génération...",
        retryWithTokens: "Réessayer ({{count}} jetons)",
        generateWithTokens: "Générer ({{count}} jetons)",
        machineSettings: "Paramètres machine",
        machineBrand: "Marque de machine",
        fileFormat: "Format de fichier",
        selectFormatSupport: "Sélectionnez le format de fichier pris en charge par votre machine {{brand}}",
        embroiderySize: "Taille de broderie",
        sizeCm: "{{size}} cm",
        sizeCostHint: "Influence le coût de la broderie. Les grandes tailles coûtent plus de jetons.",
        saveDesign: "Enregistrer le design",
        next: "Suivant",
        addToCart: "Ajouter au panier",
        clear: "Effacer"
      },
      adminDashboard: {
        failedLoadOrders: "Échec du chargement des commandes",
        failedLoadOrdersRetry: "❌ Échec du chargement des commandes. Veuillez réessayer.",
        failedLoadOrderDetails: "❌ Échec du chargement des détails de la commande.",
        orderStatusUpdated: "✅ Statut de la commande mis à jour avec succès",
        failedUpdateStatus: "Échec de la mise à jour du statut",
        failedUpdateStatusShort: "❌ Échec de la mise à jour du statut.",
        selectAtLeastOneFile: "❌ Veuillez sélectionner au moins un fichier",
        mustUploadRequestedFormat: "❌ Vous devez importer un fichier dans le format demandé : {{format}}. Les autres formats ne sont pas requis.",
        onlyRequestedNeeded: "⚠️ Seul le format demandé ({{format}}) est nécessaire. Les formats supplémentaires seront ignorés.",
        filesUploaded: "✅ Fichiers importés avec succès",
        failedUploadFiles: "Échec de l'import des fichiers",
        failedUploadFilesRetry: "❌ Échec de l'import des fichiers. Veuillez réessayer.",
        failedUploadResources: "Échec de l'import des ressources",
        failedUploadResourcesShort: "❌ Échec de l'import des ressources.",
        deleteResourceConfirm: "Voulez-vous vraiment supprimer cette ressource ?",
        resourceDeleted: "✅ Ressource supprimée",
        failedDeleteResource: "❌ Échec de la suppression de la ressource.",
        updatingOrderStatus: "Mise à jour du statut de la commande...",
        uploadingFiles: "Import des fichiers...",
        loadingOrders: "Chargement des commandes...",
        title: "Tableau de bord admin",
        tabOrders: "Commandes",
        tabTokenPricing: "Tarification des jetons",
        tabTokenCosts: "Coûts des jetons",
        tabSizePricing: "Tarification des tailles",
        tabBlog: "Blog",
        tabUsers: "Utilisateurs",
        subtitle: "Gérez et traitez les commandes de numérisation de broderie",
        searchPlaceholder: "Rechercher par ID de commande, design ou utilisateur...",
        allOrders: "Toutes les commandes",
        submitted: "Soumise",
        orderCount_one: "{{count}} commande",
        orderCount_other: "{{count}} commandes",
        noOrders: "Aucune commande trouvée",
        tryAdjustSearch: "Essayez d'ajuster votre recherche",
        ordersAppearHint: "Les commandes apparaîtront ici une fois soumises",
        orderId: "ID commande",
        design: "Design",
        user: "Utilisateur",
        date: "Date",
        status: "Statut",
        actions: "Actions",
        untitledDesign: "Design sans titre",
        viewDetails: "Voir les détails",
        orderNumber: "Commande #{{id}}",
        orderStatus: "Statut de la commande",
        orderCost: "💰 Coût de la commande",
        embroiderySize: "Taille de broderie",
        sizeCm: "{{size}} cm",
        tokensUsed: "Jetons utilisés",
        tokensCount: "{{count}} jetons",
        machineSettingsCustomer: "⚙️ Paramètres machine (sélection client)",
        notSpecified: "Non spécifié",
        requestedFormat: "Format demandé",
        customerInfo: "Informations client",
        name: "Nom",
        email: "Email",
        designInfo: "Informations du design",
        designPreview: "Aperçu du design",
        image: "Image",
        designImage: "Image du design",
        designName: "Nom du design",
        untitled: "Sans titre",
        aiStyle: "Style IA",
        designDimensionsCanvas: "📐 Dimensions du design et canevas",
        designSizeMm: "Taille du design (mm)",
        hoopSize: "Taille du cadre",
        canvasPx: "Canevas (px)",
        rotation: "Rotation",
        mirrored: "Miroir",
        productionChecklist: "✓ Checklist de production",
        checkReviewSpecs: "Vérifier toutes les spécifications du design ci-dessus",
        checkApplyThreadColors: "Appliquer {{count}} couleur(s) de fil comme spécifié",
        checkUseStitchDensity: "Utiliser la densité de points : {{density}}",
        high: "Élevée",
        checkAddTextLayer: "Ajouter la couche texte : \"{{text}}\"",
        checkDigitizeFormats: "Numériser les {{count}} formats demandés",
        checkUploadAndComplete: "Importer les fichiers et marquer la commande comme \"terminée\"",
        requestedFileFormats: "Formats de fichiers demandés",
        noSpecificFormats: "Aucun format spécifique demandé (par défaut : DST, PES, JEF)",
        uploadEmbroideryFiles: "Importer les fichiers de broderie",
        chatWithCustomer: "Discuter avec le client",
        addResources: "Ajouter des ressources",
        extraResources: "Ressources supplémentaires ({{count}})",
        deleteResource: "Supprimer la ressource",
        uploadedFiles: "Fichiers importés",
        uploadRequestedFormatHint: "Importez le fichier de broderie dans le format demandé par le client :",
        customerRequestedFormatRequired: "🎯 Format demandé par le client (requis) :",
        uploadFormatFile: "Importer le fichier {{format}}",
        important: "Important",
        onlyRequestedToComplete: "Seul le format demandé ({{format}}) est requis. Importez uniquement ce format pour finaliser la commande.",
        adminNotesOptional: "Notes admin (optionnel)",
        adminNotesPlaceholder: "Ajoutez des notes sur cette commande...",
        cancel: "Annuler",
        uploading: "Import en cours...",
        uploadFiles: "Importer les fichiers",
        resourcesHintPrefix: "📁 Importez des fichiers supplémentaires pour le client. Ils sont",
        optional: "optionnels",
        resourcesHintSuffix: "et non requis pour finaliser la commande.",
        selectFiles: "Sélectionner des fichiers",
        descriptionOptional: "Description (optionnelle)",
        resourceDescriptionPlaceholder: "ex. : Nuancier, images de référence...",
        uploadResources: "Importer les ressources"
      },
      signup: {
        title: "Créez votre compte",
        subtitle: "Commencez à digitaliser vos motifs de broderie dès aujourd'hui",
        agreeTermsError: "⚠️ Veuillez accepter les Conditions et la Politique de confidentialité",
        passwordMismatch: "⚠️ Les mots de passe ne correspondent pas",
        success: "✅ Inscription réussie ! Vérifiez votre email pour activer votre compte.",
        registrationFailed: "Échec de l'inscription",
        genericError: "❌ Une erreur est survenue. Veuillez réessayer.",
        oauthSoon: "inscription bientôt disponible !",
        googleAuthFailed: "La connexion Google a échoué. Veuillez réessayer.",
        googleConfigMissing: "La connexion Google n'est pas configurée.",
        fullName: "Nom complet",
        fullNamePlaceholder: "Jean Dupont",
        email: "Adresse email",
        emailPlaceholder: "vous@exemple.com",
        password: "Mot de passe",
        passwordHint: "Doit contenir au moins 8 caractères",
        confirmPassword: "Confirmer le mot de passe",
        agreeTo: "J'accepte les",
        terms: "Conditions",
        and: "et la",
        privacy: "Politique de confidentialité",
        creating: "Création du compte...",
        createAccount: "Créer un compte",
        orSignUpWith: "Ou s'inscrire avec",
        alreadyHaveAccount: "Vous avez déjà un compte ? ",
        signIn: "Se connecter"
      },
      forgotPassword: {
        title: "Mot de passe oublié ?",
        subtitle: "Entrez votre email et nous vous enverrons un lien de réinitialisation",
        email: "Adresse email",
        emailPlaceholder: "vous@exemple.com",
        sending: "Envoi...",
        sendResetLink: "Envoyer le lien",
        backToSignIn: "Retour à la connexion",
        checkEmail: "Vérifiez votre email",
        sentMessage: "Si votre email existe, vous recevrez un lien de réinitialisation sous peu.",
        failedSend: "Échec de l'envoi de l'email",
        networkError: "Erreur réseau. Veuillez réessayer."
      },
      resetPassword: {
        title: "Réinitialisez votre mot de passe",
        subtitle: "Entrez votre nouveau mot de passe ci-dessous",
        newPassword: "Nouveau mot de passe",
        newPasswordPlaceholder: "Entrez le nouveau mot de passe",
        confirmPassword: "Confirmer le mot de passe",
        confirmPasswordPlaceholder: "Confirmez le nouveau mot de passe",
        resetPassword: "Réinitialiser le mot de passe",
        resetting: "Réinitialisation...",
        passwordLength: "Le mot de passe doit contenir au moins 8 caractères",
        passwordMismatch: "Les mots de passe ne correspondent pas",
        invalidLink: "Lien de réinitialisation invalide",
        successTitle: "Mot de passe réinitialisé !",
        successMessage: "Votre mot de passe a été réinitialisé avec succès.",
        resetFailed: "Échec de la réinitialisation du mot de passe",
        networkError: "Erreur réseau. Veuillez réessayer.",
        redirecting: "Redirection vers la connexion..."
      },
      verifyEmail: {
        verifyingTitle: "Vérification de votre email",
        verifyingSubtitle: "Veuillez patienter pendant la vérification de votre adresse email...",
        successTitle: "Email vérifié ! 🎉",
        successMessage: "Votre email a été vérifié.",
        welcome: "Bienvenue, {{username}} !",
        tokensInfo: "Vous avez {{tokens}} jetons pour commencer à créer.",
        redirecting: "Redirection vers l'application...",
        failedTitle: "Échec de vérification",
        failedMessage: "La vérification de l'email a échoué.",
        invalidLink: "Lien de vérification invalide",
        networkError: "Échec de la vérification de l'email. Veuillez réessayer.",
        returnLogin: "Retour à la connexion"
      },
      paymentSuccess: {
        verifyingTitle: "Vérification du paiement...",
        verifyingSubtitle: "Veuillez patienter pendant la confirmation de votre achat",
        noSessionId: "Aucun identifiant de session trouvé",
        verifyFailed: "Échec de la vérification du paiement",
        verifyError: "Erreur lors de la vérification du paiement",
        errorTitle: "Erreur de paiement",
        returnToApp: "Retour à l'application",
        title: "Paiement réussi !",
        subtitle: "Vos jetons ont été ajoutés à votre compte",
        tokenBalance: "Votre solde de jetons",
        tokens: "jetons",
        whatCanDo: "Ce que vous pouvez faire avec vos jetons :",
        aiImages: "🎨 Générer des images IA : {{count}} jetons",
        placeOrder: "📥 Passer une commande : {{count}} jetons",
        startCreating: "Commencer à créer"
      },
      paymentCancel: {
        title: "Paiement annulé",
        subtitle: "Votre paiement a été annulé. Aucun montant n'a été débité.",
        whatHappened: "Que s'est-il passé ?",
        details: "Vous pouvez fermer la fenêtre de paiement à tout moment en toute sécurité. Si vous avez rencontré un problème lors du paiement, réessayez ou contactez notre équipe support.",
        tryAgain: "Réessayer",
        backToDashboard: "Retour au tableau de bord",
        needHelp: "Besoin d'aide ?",
        contactSupport: "Contacter le support"
      },
      signin: {
        title: "Bon retour",
        subtitle: "Connectez-vous pour continuer à créer",
        loginSuccess: "✅ Connexion réussie ! Redirection...",
        invalidCredentials: "Identifiants invalides",
        genericError: "❌ Une erreur est survenue. Veuillez réessayer.",
        verificationSent: "✅ Email de vérification envoyé ! Vérifiez votre boîte mail.",
        failedResend: "Échec du renvoi de l'email",
        oauthSoon: "connexion bientôt disponible !",
        googleAuthFailed: "La connexion Google a échoué. Veuillez réessayer.",
        googleConfigMissing: "La connexion Google n'est pas configurée.",
        resendVerification: "Cliquez ici pour renvoyer l'email de vérification",
        emailOrUsername: "Email ou nom d'utilisateur",
        emailPlaceholder: "email@exemple.com ou nom d'utilisateur",
        password: "Mot de passe",
        hidePassword: "Masquer le mot de passe",
        showPassword: "Afficher le mot de passe",
        rememberMe: "Se souvenir de moi",
        forgotPassword: "Mot de passe oublié ?",
        signingIn: "Connexion...",
        signIn: "Se connecter",
        orContinueWith: "Ou continuer avec",
        noAccount: "Vous n'avez pas de compte ? ",
        signUpFree: "Inscription gratuite"
      },
      dashboard: {
        loading: "Chargement...",
        titleNewDesign: "Nouveau design",
        titleDashboard: "tableau de bord",
        titleCart: "panier",
        titleOrders: "commandes",
        titleTokens: "jetons",
        titleSettings: "paramètres",
        titleMessages: "messages",
        titleAdmin: "admin",
        navAdmin: "Panneau admin",
        navNewDesign: "Nouveau design",
        navMyDesigns: "Mes designs",
        navCart: "Panier",
        navOrders: "Commandes",
        navMessages: "Messages",
        navBuyTokens: "Acheter des jetons",
        navSettings: "Paramètres",
        navHowItWorks: "Comment ça marche",
        titleHowItWorks: "Comment ça marche",
        tokenLabel: "Jetons",
        tokenLeft: "{{count}} restants",
        topup: "Recharger le solde",
        signOut: "Déconnexion",
        proPlan: "Plan Pro",
        cartTitle: "Panier"
      },
      howItWorks: {
        heroBadge: "Simple & Facile",
        heroTitle: "Comment ça marche",
        heroSubtitle: "Transformez vos idées en fichiers de broderie professionnels en quelques étapes simples. Notre plateforme alimentée par l'IA rend tout facile.",
        step1Title: "Décrivez votre design",
        step1Desc: "Dites à notre IA ce que vous voulez — décrivez votre idée de broderie en mots, choisissez votre style et laissez la magie opérer.",
        step2Title: "L'IA génère votre design",
        step2Desc: "Notre IA avancée crée un magnifique design prêt pour la broderie. Prévisualisez-le instantanément et ajustez si besoin.",
        step3Title: "Ajoutez au panier",
        step3Desc: "Satisfait de votre design ? Ajoutez-le à votre panier. Personnalisez la taille de broderie et sélectionnez le format de votre machine.",
        step4Title: "Payez avec des jetons",
        step4Desc: "Utilisez vos jetons pour passer la commande. Nos digitaliseurs professionnels convertiront votre design en fichier de broderie.",
        step5Title: "Téléchargez vos fichiers",
        step5Desc: "Une fois digitalisé, téléchargez vos fichiers de broderie dans le format choisi — prêts à charger sur votre brodeuse !",
        tipsTitle: "Conseils Pro",
        tip1: "Soyez précis dans vos descriptions pour de meilleurs résultats — mentionnez les couleurs, le style et les détails.",
        tip2: "Consultez nos forfaits de jetons pour le meilleur rapport qualité-prix — les grands forfaits offrent des jetons bonus !",
        tip3: "Vous pouvez commander plusieurs formats pour le même design afin de l'utiliser sur différentes brodeuses.",
        ctaTitle: "Prêt à créer ?",
        ctaDesc: "Commencez à concevoir vos fichiers de broderie personnalisés grâce à la puissance de l'IA. Cela ne prend que quelques minutes !",
        ctaButton: "Créer mon design"
      },
      landing: {
        login: "Connexion",
        getStarted: "Commencer",
        heroBadge: "Numérisation de broderie par IA",
        heroTitle1: "Transformez vos idées en",
        heroHighlight: "fichiers de broderie",
        heroTitle2: "avec l'IA",
        heroSubtitle: "Décrivez votre design et notre IA génère des fichiers de broderie professionnels pour toute machine. 21+ formats et 17 marques — du concept au point en quelques minutes.",
        heroCtaPrimary: "Commencer gratuitement",
        heroCtaSecondary: "Comment ça marche",
        statFormats: "Formats de fichier",
        statBrands: "Marques de machines",
        statFreeTokens: "Jetons gratuits à l'inscription",
        brandsLabel: "Compatible avec toutes les grandes marques de brodeuses",
        howTag: "Comment ça marche",
        howTitle: "De l'idée à la broderie en 3 étapes",
        howDesc: "Aucune compétence en design requise. Notre IA et nos digitaliseurs professionnels s'occupent du travail technique.",
        step1Title: "Décrivez votre design",
        step1Desc: "Tapez une description de ce que vous voulez — un motif floral, un logo, du texte personnalisé — ou téléchargez votre propre image.",
        step2Title: "L'IA génère votre aperçu",
        step2Desc: "Notre IA transforme votre idée en aperçu style broderie. Choisissez votre marque de machine, format et taille.",
        step3Title: "Téléchargez les fichiers prêts pour la machine",
        step3Desc: "Des digitaliseurs professionnels convertissent votre design en fichiers de points. Téléchargez en PES, DST, JEF et 18+ autres formats.",
        featTag: "Pourquoi nous choisir",
        featTitle: "Tout ce qu'il faut pour la broderie",
        featDesc: "Outils professionnels et technologie IA combinés pour la meilleure expérience de numérisation de broderie.",
        feat1Title: "Design par IA",
        feat1Desc: "Générez des designs de broderie uniques à partir de descriptions textuelles grâce à la génération d'images par IA avancée.",
        feat2Title: "21+ formats de fichier",
        feat2Desc: "PES, DST, JEF, EXP, VP3, HUS et plus. Tous les formats de broderie majeurs supportés nativement.",
        feat3Title: "Délai rapide",
        feat3Desc: "Les aperçus IA sont générés instantanément. La numérisation professionnelle est réalisée rapidement par des experts.",
        feat4Title: "Paiements sécurisés",
        feat4Desc: "Tarification par jetons avec transactions protégées par Stripe. Achetez uniquement ce dont vous avez besoin, sans abonnement.",
        feat5Title: "Multi-langue",
        feat5Desc: "Support complet en anglais et français. Utilisez la plateforme dans votre langue préférée avec des traductions complètes.",
        feat6Title: "Support expert",
        feat6Desc: "Système de chat intégré pour communiquer directement avec notre équipe de numérisation sur chaque commande.",
        ctaTitle: "Prêt à donner vie à vos designs ?",
        ctaDesc: "Inscrivez-vous maintenant et commencez à créer des fichiers de broderie professionnels avec l'IA.",
        ctaButton: "Créer votre compte gratuit",
        ctaBonus: "Jetons gratuits à l'inscription — aucune carte bancaire requise",
        footerRights: "Tous droits réservés.",
        footerHome: "Accueil",
        footerAbout: "À propos",
        footerPrivacy: "Confidentialité"
      },
      privacy: {
        heroTitle: "Politique de Confidentialité",
        heroDesc: "Comment nous collectons, utilisons et protégeons vos informations personnelles.",
        tocTitle: "Sommaire",
        collectTitle: "Informations Collectées",
        collectIntro: "Nous collectons les informations que vous fournissez directement ainsi que les données générées par votre utilisation du service :",
        collectAccount: "Informations du compte",
        collectAccountDesc: "Nom, adresse e-mail et mot de passe lors de la création de votre compte, ou données de profil Google si vous utilisez OAuth.",
        collectDesign: "Données de design",
        collectDesignDesc: "Images téléversées et fichiers de broderie générés, ainsi que les paramètres tels que la taille, le format et la densité de points.",
        collectPayment: "Informations de paiement",
        collectPaymentDesc: "Coordonnées de facturation traitées de manière sécurisée via Stripe. Nous ne stockons jamais votre numéro de carte complet sur nos serveurs.",
        collectTechnical: "Données techniques",
        collectTechnicalDesc: "Adresse IP, type de navigateur, informations sur l'appareil et journaux d'utilisation collectés automatiquement pour la sécurité et l'analyse.",
        useTitle: "Utilisation de Vos Données",
        useIntro: "Vos informations sont utilisées pour :",
        use1: "Fournir et maintenir le service de conversion de fichiers de broderie.",
        use2: "Traiter les commandes et gérer votre solde de jetons.",
        use3: "Communiquer avec vous concernant votre compte ou vos commandes.",
        use4: "Améliorer nos modèles d'IA et la qualité du service.",
        use5: "Prévenir la fraude et assurer la sécurité de la plateforme.",
        cookiesTitle: "Cookies",
        cookiesIntro: "Nous utilisons un nombre limité de cookies strictement nécessaires au fonctionnement du service :",
        cookiesEssential: "Cookies de session",
        cookiesEssentialDesc: "Maintiennent votre connexion et mémorisent vos préférences pendant une session.",
        cookiesAuth: "Jetons d'authentification",
        cookiesAuthDesc: "Vérifient votre identité de manière sécurisée à chaque requête.",
        cookiesNote: "Nous n'utilisons pas de cookies publicitaires ou de suivi. Aucun cookie analytique tiers n'est installé.",
        thirdTitle: "Services Tiers",
        thirdIntro: "Nous partageons des données avec les prestataires suivants uniquement pour fournir notre service :",
        thirdStripe: "Traitement sécurisé des paiements. Soumis à la politique de confidentialité de Stripe.",
        thirdOpenai: "Analyse d'images pour la numérisation de broderie. Les images sont traitées selon la politique d'utilisation des données d'OpenAI.",
        thirdGoogle: "Authentification optionnelle. Seules les informations de profil de base (nom, e-mail, avatar) sont récupérées.",
        thirdNoSell: "Nous ne vendons jamais vos données personnelles à des tiers.",
        rightsTitle: "Vos Droits",
        rightsIntro: "En vertu des réglementations applicables en matière de protection des données (notamment le RGPD), vous avez le droit de :",
        rights1: "Accéder aux données personnelles que nous détenons à votre sujet.",
        rights2: "Corriger les données inexactes ou incomplètes.",
        rights3: "Demander la suppression de votre compte et des données associées.",
        rights4: "Exporter vos données dans un format portable.",
        rights5: "Retirer votre consentement à tout moment en nous contactant.",
        securityTitle: "Sécurité",
        securityDesc: "Nous protégeons vos données par un chiffrement HTTPS en transit, des mots de passe hachés et une infrastructure serveur sécurisée hébergée dans l'UE. L'accès aux données personnelles est limité au personnel autorisé uniquement.",
        retentionTitle: "Conservation des Données",
        retentionDesc: "Les données du compte sont conservées tant que votre compte est actif. Les images téléversées et les fichiers générés sont stockés jusqu'à 90 jours après la dernière commande, puis définitivement supprimés. Vous pouvez demander une suppression anticipée à tout moment.",
        contactTitle: "Nous Contacter",
        contactDesc: "Pour toute question ou demande relative à la confidentialité, veuillez nous écrire à contact@aiembroideryfiles.com. Nous nous efforçons de répondre sous 48 heures.",
        lastUpdated: "Dernière mise à jour : juin 2025"
      },
      about: {
        heroTitle: "À Propos",
        heroDesc: "Nous construisons l'avenir de la numérisation de broderie — propulsé par l'IA, conçu pour les créateurs.",
        missionTag: "Notre Mission",
        missionTitle: "Rendre la Broderie Professionnelle Accessible à Tous",
        missionDesc: "La numérisation de broderie traditionnelle est lente, coûteuse et réservée aux spécialistes. Nous combinons l'intelligence artificielle avec une connaissance approfondie de la broderie machine pour livrer des fichiers prêts à produire en minutes — pas en jours. Que vous dirigiez une petite entreprise artisanale ou un grand atelier de production, notre plateforme vous offre des résultats professionnels à une fraction du coût.",
        card1Title: "Numérisation par IA",
        card1Desc: "Téléversez n'importe quelle image et notre IA analyse les couleurs, formes et textures pour générer des fichiers de broderie optimisés pour votre machine.",
        card2Title: "21+ Formats de Sortie",
        card2Desc: "Du DST au PES en passant par le JEF, VP3 et bien d'autres — nous supportons tous les principaux formats de machines à broder.",
        card3Title: "Livraison Instantanée",
        card3Desc: "Plus besoin d'attendre des jours qu'un numériseur réponde. Obtenez vos fichiers de broderie générés et prêts à télécharger en quelques minutes.",
        statFormats: "Formats de sortie",
        statBrands: "Marques de machines",
        statLanguages: "Langues",
        statAvailability: "Disponibilité",
        valuesTitle: "Nos Valeurs",
        val1Title: "Passion de l'Artisanat",
        val1Desc: "Nous aimons la broderie et comprenons le soin apporté à chaque point.",
        val2Title: "La Précision d'Abord",
        val2Desc: "Chaque fichier est optimisé pour des points nets, une densité adaptée et des couleurs fidèles.",
        val3Title: "Transparence",
        val3Desc: "Tarification claire avec un système de jetons — pas de frais cachés, aucun abonnement obligatoire.",
        val4Title: "Confiance & Confidentialité",
        val4Desc: "Vos designs restent les vôtres. Nous ne partageons ni ne réutilisons jamais vos images.",
        ctaTitle: "Prêt à Essayer ?",
        ctaDesc: "Créez votre compte gratuit et commencez à convertir vos images en fichiers de broderie dès aujourd'hui.",
        ctaButton: "Commencer Gratuitement"
      },
      blog: {
        navTitle: "Blog",
        heroTitle: "Notre Blog",
        heroDesc: "Astuces, tutoriels et actualit\u00e9s sur la num\u00e9risation de broderie et notre plateforme.",
        readMore: "Lire la suite",
        prev: "Pr\u00e9c\u00e9dent",
        next: "Suivant",
        emptyTitle: "Aucun Article",
        emptyDesc: "Nous pr\u00e9parons du contenu de qualit\u00e9. Revenez bient\u00f4t !",
        notFound: "Article Introuvable",
        notFoundDesc: "Cet article de blog n\u2019existe pas ou a \u00e9t\u00e9 supprim\u00e9.",
        backToList: "Retour au Blog"
      },
      blogAdmin: {
        subtitle: "Cr\u00e9ez et g\u00e9rez vos articles de blog.",
        newPost: "Nouvel Article",
        editPost: "Modifier l\u2019Article",
        back: "Retour",
        titleLabel: "Titre",
        titlePlaceholder: "Entrez le titre de l\u2019article...",
        excerptLabel: "Extrait",
        excerptPlaceholder: "Court r\u00e9sum\u00e9 affich\u00e9 dans la liste du blog...",
        coverLabel: "Image de Couverture",
        chooseCover: "Choisir une Image",
        contentLabel: "Contenu",
        contentPlaceholder: "\u00c9crivez votre article ici...",
        metaLabel: "M\u00e9ta Description",
        metaPlaceholder: "Description SEO pour les moteurs de recherche...",
        draft: "Brouillon",
        published: "Publi\u00e9",
        publish: "Publier",
        unpublish: "D\u00e9publier",
        save: "Enregistrer",
        saving: "Enregistrement...",
        created: "Article cr\u00e9\u00e9 avec succ\u00e8s.",
        updated: "Article mis \u00e0 jour avec succ\u00e8s.",
        deleted: "Article supprim\u00e9.",
        titleRequired: "\u274c Le titre est obligatoire.",
        loadError: "\u274c \u00c9chec du chargement des articles.",
        saveError: "\u274c \u00c9chec de l\u2019enregistrement.",
        deleteError: "\u274c \u00c9chec de la suppression.",
        confirmDelete: "\u00cates-vous s\u00fbr de vouloir supprimer cet article ?",
        noPosts: "Aucun article. Cliquez sur \"Nouvel Article\" pour en cr\u00e9er un."
      },
      userManagement: {
        title: "Gestion des utilisateurs",
        searchPlaceholder: "Rechercher par nom, e-mail ou nom d'utilisateur...",
        search: "Rechercher",
        username: "Nom d'utilisateur",
        email: "E-mail",
        name: "Nom",
        tokens: "Jetons",
        verified: "V\u00e9rifi\u00e9",
        staff: "Admin",
        active: "Actif",
        joined: "Inscrit le",
        actions: "Actions",
        firstName: "Pr\u00e9nom",
        lastName: "Nom",
        edit: "Modifier",
        delete: "Supprimer",
        save: "Enregistrer",
        cancel: "Annuler",
        confirmDelete: "Confirmer ?",
        userUpdated: "Utilisateur mis \u00e0 jour avec succ\u00e8s.",
        userDeleted: "Utilisateur supprim\u00e9 avec succ\u00e8s.",
        loadError: "\u00c9chec du chargement des utilisateurs.",
        updateError: "\u00c9chec de la mise \u00e0 jour de l'utilisateur.",
        deleteError: "\u00c9chec de la suppression de l'utilisateur.",
        noUsers: "Aucun utilisateur trouv\u00e9.",
        totalUsers: "Total utilisateurs",
        resetPwd: "Mot de passe",
        resetPassword: "R\u00e9initialiser le mot de passe",
        resetPasswordDesc: "D\u00e9finir un nouveau mot de passe pour {{username}}.",
        newPassword: "Nouveau mot de passe (min. 8 caract\u00e8res)",
        passwordReset: "Mot de passe r\u00e9initialis\u00e9 avec succ\u00e8s.",
        passwordResetError: "\u00c9chec de la r\u00e9initialisation du mot de passe.",
        passwordMinLength: "Le mot de passe doit contenir au moins 8 caract\u00e8res.",
        saving: "Enregistrement..."
      }
    }
  }
};

const getDomainLanguage = () => {
  if (typeof window === "undefined") return "en";

  const host = window.location.hostname.toLowerCase();

  if (host === "broderiemagique.com" || host === "www.broderiemagique.com") {
    return "fr";
  }

  return "en";
};

const getDomainTitle = () => {
  if (typeof window === "undefined") return "AI Embroidery Files";

  const host = window.location.hostname.toLowerCase();

  if (host === "broderiemagique.com" || host === "www.broderiemagique.com") {
    return "Broderie Magique";
  }

  return "AI Embroidery Files";
};

const storedLanguage = typeof window !== "undefined"
  ? localStorage.getItem("app_language")
  : null;

const initialLanguage = storedLanguage || getDomainLanguage();

i18n.use(initReactI18next).init({
  resources,
  lng: initialLanguage,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false
  }
});

if (typeof window !== "undefined") {
  document.documentElement.lang = i18n.language;
  document.title = getDomainTitle();
  i18n.on("languageChanged", (lng) => {
    document.documentElement.lang = lng;
    document.title = getDomainTitle();
    localStorage.setItem("app_language", lng);
  });
}

export default i18n;
